'use client';

import { useFormContext } from 'react-hook-form';

import { PasswordInput as ChakraPasswordInput } from '@packages/web-design-systems';
import type { PasswordInputProps as ChakraPasswordInputProps } from '@packages/web-design-systems';

import type { FormBaseInputProps } from '../../../types';
import { FormFloatingField } from '../../wrapper';

export type PasswordInputProps<T> = FormBaseInputProps<T> & Omit<ChakraPasswordInputProps, 'name'>;

export const PasswordInput = <T extends Record<string, unknown>>({
	helperText,
	label,
	name,
	optionalText,
	required,
	...passwordInputProps
}: PasswordInputProps<T>) => {
	const { register } = useFormContext<T>();

	return (
		<FormFloatingField
			helperText={helperText}
			label={label}
			name={name}
			optionalText={optionalText}
			required={required}
		>
			<ChakraPasswordInput {...register(name)} {...passwordInputProps} />
		</FormFloatingField>
	);
};
